<template>
  <div class="app-container">
    <div class="top">
      <div class="block">
        <div class="title">
          <div class="left">最高/最低 温度</div>
          <div class="right show-btn">今日</div>
        </div>
        <div class="content">
          -
        </div>
        <div class="bottom">
          <div class="left">昨日数据</div>
          <div class="right">-</div>
        </div>
      </div>
      <div class="block">
        <div class="title">
          <div class="left">最高/最低 湿度</div>
          <div class="right show-btn">今日</div>
        </div>
        <div class="content">
          -
        </div>
        <div class="bottom">
          <div class="left">昨日数据</div>
          <div class="right">-</div>
        </div>
      </div>
      <div class="block">
        <div class="title">
          <div class="left">最高/最低 光照</div>
          <div class="right show-btn">今日</div>
        </div>
        <div class="content">
          -
        </div>
        <div class="bottom">
          <div class="left">昨日数据</div>
          <div class="right">-</div>
        </div>
      </div>
    </div>
    <div class="echartsContainer">
      <div class="title">数据查询</div>
      <div class="left">
        <div class="content">
          <div class="search">
            <el-date-picker v-model="sTimeStr" type="datetime" placeholder="选择开始时间" align="right" :picker-options="pickerOptions" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
            <el-date-picker v-model="eTimeStr" type="datetime" placeholder="选择结束时间" align="right" :picker-options="pickerOptions" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
            <el-button type="success" size="medium" @click="choseQueryData()" style="margin-left: 5px;">查询统计</el-button>
            <el-button :type="intervalTimeType==1?'success':'primary'" size="medium" @click="choseIntervalTimeType(1)" style="margin-left: 5px;">间隔一小时</el-button>
            <el-button :type="intervalTimeType==2?'success':'primary'" size="medium" @click="choseIntervalTimeType(2)" style="margin-left: 5px;">间隔半小时</el-button>
            <el-button :type="intervalTimeType==3?'success':'primary'" size="medium" @click="choseIntervalTimeType(3)" style="margin-left: 5px;">间隔一刻钟</el-button>
          </div>
          <div class="search" style="margin-top: 10px;">
            <el-button style="margin-top: 1px;margin-left: 1px;" v-for="(item) in devices" @click="choseDeviceForChart(item)" :key="item.name" :value="item.id" :type="item.id==choseChartDevice.id?'success':'primary'" size="mini">{{ item.name }}</el-button>
          </div>          
          <div class="search" style="margin-top: 10px;">
            <el-button style="margin-top: 1px;margin-left: 1px;" v-for="(item) in chartDeviceProperties" @click="choseProperty(item)" :key="item.paramName" :value="item.paramName" :type="choseStrChartDeviceProperty.indexOf('-'+item.paramName+'-')!=-1?'success':'primary'" size="mini" v-if="item.method.indexOf('R')!=-1 && (item.property.dataType=='integer'||item.property.dataType=='float')">{{ item.name }}</el-button>
          </div>
          <div class="charts" id="chart"></div>
        </div>
      </div>
      <div class="right">
        <div class="content">
          <el-timeline>
            <el-timeline-item v-for="(message) in deviceControlMessages" :key="message.id" :value="message.id" :timestamp="formatDate(message.addTime)">
              <div>
                {{ message.msg }}
              </div>
            </el-timeline-item>
          </el-timeline>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import requestService from '../../../util/request'
import { formatDate } from '../../../util/date'
import * as echarts from 'echarts'

export default {
  data () {
    return {
      currentLog: 1,
      pageSizeLog: 15,
      deviceControlMessages: [],
      deviceDataMessages: [],
      devices: [],
      choseChartDevice: {},
      chartDeviceProperties: [],
      choseChartDevicePropertites: [],
      choseStrChartDeviceProperty: '-',
      intervalTimeType: 1,
      sTimeStr: '',
      eTimeStr: '',
      myChart: null,
      pickerOptions: {
        shortcuts: [{
          text: '今天',
          onClick (picker) {
            picker.$emit('pick', new Date())
          }
        }, {
          text: '昨天',
          onClick (picker) {
            const date = new Date()
            date.setTime(date.getTime() - 3600 * 1000 * 24)
            picker.$emit('pick', date)
          }
        }, {
          text: '一周前',
          onClick (picker) {
            const date = new Date()
            date.setTime(date.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', date)
          }
        }]
      }
    }
  },
  created () {
    this.queryDevices()
  },
  mounted () {
    this.myChart = echarts.init(document.getElementById('chart'))
  },
  methods: {
    choseIntervalTimeType (val) {
      this.intervalTimeType = val
    },
    choseQueryData () {
      this.loadChartsData()
      this.queryControlLog()
    },
    choseProperty (property) {
      if(this.choseStrChartDeviceProperty.indexOf('-'+property.paramName+'-')!=-1){
        this.choseStrChartDeviceProperty = this.choseStrChartDeviceProperty.replace('-'+property.paramName+'-', '-');
        for(let index in this.choseChartDevicePropertites){
          let item = this.choseChartDevicePropertites[index]
          if(item.paramName==property.paramName){
            this.choseChartDevicePropertites.splice(index, 1)
            break;
          }
        }
      }else{
        this.choseStrChartDeviceProperty = this.choseStrChartDeviceProperty + property.paramName + '-';
        this.choseChartDevicePropertites.push(property)
      }
      this.initChart(this.deviceDataMessages, this.choseChartDevicePropertites)
    },
    queryDevices () {
      let that = this
      that.devices = []
      requestService.get(`/deviceInstantiation/listPage?current=1&pageSize=65535`, {
      }, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}}).then((res) => {
        let tempDevices = []
        if (res.data.body.records && res.data.body.records.length > 0) {
          for (let device of res.data.body.records) {
            if (!device.perprotiesValues) {
                continue;
              }
            for (let property of device.perprotiesValues) {
              if (!property.property) {
                continue;
              }
              if (property.property.dataType=='integer' || property.property.dataType=='float') {
                tempDevices.push(device)
                break
              }
            }
          }
        }
        that.devices = tempDevices
        if (that.devices && that.devices.length > 0) {
          that.choseDeviceForChart(that.devices[0])
        }
      })
    },
    queryControlLog () {
      let that = this
      that.deviceControlMessages = []
      let url = `/deviceInstantiationMsgLog/listControlPage?current=${that.currentLog}&pageSize=${that.pageSizeLog}&sTimeStr=${this.sTimeStr}&eTimeStr=${this.eTimeStr}`
      if (this.choseChartDevice && this.choseChartDevice.serialNo) {
        url = url + '&serialNo=' + this.choseChartDevice.serialNo
      }
      requestService.get(url, {
      }, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}}).then((res) => {
        that.deviceControlMessages = res.data.body.records
      })
    },
    choseDeviceForChart (device) {
      this.choseChartDevice = device
      this.chartDeviceProperties = device.perprotiesValues
      if (this.chartDeviceProperties && this.chartDeviceProperties.length > 0) {
        this.loadChartsData(this.chartDeviceProperties[0])
      }
      this.queryControlLog()
    },
    loadChartsData (property) {
      let that = this
      if (!this.choseChartDevice) {
        return
      }
      if(property){
        this.choseChartDevicePropertites = []
        this.choseStrChartDeviceProperty = '-'
      }
      requestService.get(`/deviceInstantiationMsgLog/listUploadDataForStat?deviceInstantiationId=${this.choseChartDevice.id}&intervalTimeType=${this.intervalTimeType}&injectControlMessage=false&sTimeStr=${this.sTimeStr}&eTimeStr=${this.eTimeStr}`, {
      }, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}}).then((res) => {
        that.deviceDataMessages = res.data.body
        if(property){
          that.choseProperty(property)
        }else{
          that.initChart(that.deviceDataMessages, that.choseChartDevicePropertites)
        }
      })
    },
    initChart (msgs, propertites) {
      let that = this
      let xdata = []
      let ydatas = []
      let legendData = []
      let minData = 999999999
      let maxData = 0
      for (let msg of msgs) {
        xdata.push(that.formatDate2(msg.addTime))
      } 
      for(let property of propertites){
        console.log(property.name)
        legendData.push(property.name)
        let ydata = []
        for (let msg of msgs) {
          let propertyVal = JSON.parse(msg.msg)
          if(!propertyVal){
            propertyVal = {}
          }
          if(!propertyVal[property.paramName]){
            propertyVal[property.paramName]='0'
          }
          let tempVal = parseFloat(propertyVal[property.paramName])
          if (tempVal > maxData) {
            maxData = tempVal
          }
          if (tempVal < minData) {
            minData = tempVal
          }
          ydata.push(propertyVal[property.paramName])
        }
        ydatas.push({type: 'line', data: ydata, smooth: true, name: property.name})
      }
      // console.log('minData:' + minData + '-maxData:' + maxData)
      // console.log(xdata)
      // console.log(ydata)

      that.myChart.setOption({
        toolbox: {
          show: false
        },
        title: {
          show: false
        },
        legend: {
          show: true,
          legendData: []
        },        
        tooltip: {},
        grid: {
          top: '6%',
          right: '6%',
          bottom: '5%',
          left: '2%',
          containLabel: true,
          show: false
        },        
        xAxis: [{
          data: xdata
        }],
        yAxis: [{
          min: minData,
          max: maxData
        }],
        series: ydatas
      })
    },
    formatDate (time) {
      var date = new Date(time)
      return formatDate(date, 'yyyy-MM-dd hh:mm:ss')
    },
    formatDate2 (time) {
      var date = new Date(time)
      return formatDate(date, 'hh:mm')
    }
  }
}
</script>

<style scoped>
.app-container {
  width: 100%;
  background-color: #F5F5F5;
  height: calc(100vh - 56px - 20px);
  .top{
    width: 100%;
    height: 190px;
    .block{
      width: 32%;
      margin-left: 1%;
      height: 175px;
      float: left;
      border-radius: 4px;
      background-color: #FFFFFF;
      .title{
        width: 94%;
        margin-left: 3%;
        height: 45px;
        .left{
          float: left;
          width: 50%;
          font-size: 16px;
          font-weight: bold;
          letter-spacing: 1px;
          line-height: 45px;
        }
        .right{
          float: right;
          width: 50%;
        }
        .show-btn{
          border: 1px solid #209323;
          background-color: #209323;
          color: #FFFFFF;
          border-radius: 2px;
          line-height: 21px;
          width: 40px;
          text-align: center;
          font-size: 12px;
          margin-top: 12px;
        }
      }
      .content{
        width: 94%;
        margin-left: 3%;
        height: 85px;
        font-size: 36px;
        font-weight: bold;
        letter-spacing: 1px;
        border-bottom: 1px solid #F5F5F5;
        line-height: 85px;
      }
      .bottom{
        width: 94%;
        margin-left: 3%;
        float: left;
        height: 45px;
        .left{
          float: left;
          width: 50%;
          font-size: 14px;
          font-weight: bold;
          letter-spacing: 1px;
          line-height: 45px;
        }
        .right{
          float: right;
          width: 50%;
          text-align: right;
          font-size: 14px;
          font-weight: bold;
          letter-spacing: 1px;
          line-height: 45px;
        }
      }
    }
  }
  .echartsContainer{
    width: 98%;
    height: calc(100vh - 56px - 20px - 200px);
    margin-left: 1%;
    border-radius: 4px;
    background-color: #FFFFFF;
    .title{
      width: 98%;
      height: 50px;
      margin-left: 1%;;
      line-height: 50px;
    }
    .left{
      width: 69%;
      float: left;
      height: calc(100vh - 56px - 20px - 200px - 100px);
      margin-left: 1%;
      .content{
        .serach{
          width: 100%;
          height: 80px;
        }
        .charts{
          width: 100%;
          height: calc(100vh - 56px - 20px - 200px - 100px - 180px);
        }
      }
    }
    .right{
      width: 29%;
      float: right;
      height: 720px;
      margin-right: 1%;
      .content{
        width: 100%;
        height: 720px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/org-manage-components/analysis/Index.vue